import { Flex } from 'components/Flex';

import { Fragment, useState } from 'react';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSelector } from 'react-redux';
import { FEATURE_SELECTORS_MAP } from 'guards/FeatureGuard.constants';
import { useCanAssignValidationContext } from 'modals/ShiftModal/src/views/DetailView/ConfirmAvailabilityModal/CanAssignValidation.validation.context';
import { WebDetailViewFooter } from 'modals/ShiftModal/src/views/DetailView/WebDetailViewFooter';
import { useResponsive } from 'providers/ResponsiveProvider/Responsive';
import { MobileDetailViewFooter } from 'modals/ShiftModal/src/views/DetailView/MobileDetailViewFooter';
import { IDetailViewFooterProps } from 'modals/ShiftModal/src/views/DetailView/DetailView.types';
import { useShiftModalPropsContext } from 'modals/ShiftModal/ShiftModal.props.context';

export function DetailViewFooter() {
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  const { goToDeleteView, goToEditView, goToReleaseShiftView, goToSendToAgenciesView } =
    useShiftModalPropsContext();

  const isReadOnly = useSelector(
    FEATURE_SELECTORS_MAP['FEATURE_TYPE_YMCA_READ_ONLY_SECONDARY_USER'],
  );

  const { validateAndExecute } = useCanAssignValidationContext();
  const { isMobile } = useResponsive();
  const Footer = isMobile ? MobileDetailViewFooter : WebDetailViewFooter;

  const [isBlockDeleteConfirmationOpen, setIsBlockDeleteConfirmationOpen] = useState(false);

  if (!order || isReadOnly) return <Fragment />;

  const props: IDetailViewFooterProps = {
    order,
    validateAndExecute,
    goToSendToAgenciesView,
    goToReleaseShiftView,
    goToEditView,
    goToDeleteView,
    isBlockShift: !!order.isBlockShift,
    isBlockDeleteConfirmationOpen,
    setIsBlockDeleteConfirmationOpen,
  };

  return (
    <Flex justifyContent="space-between" width="100%">
      <Footer {...props} />
    </Flex>
  );
}
